// ### Imports
// * Import lib
import React from "react";

// * Import 3rd party lib
import { CircularProgress, useTheme } from "@mui/material";
import { makeStyles } from "@mui/styles";

// * Import kits
import Box from "../../kit/Box";
import Typography from "../../kit/Typography";

import errorImageLight from "../../../assets/images/No_Data.svg";
import errorImageDark from "../../../assets/images/dark_theme/No_data_dark.svg";
import LoadingImageLight from "../../../assets/images/LoadingImage.svg";
import LoadingImageDark from "../../../assets/images/dark_theme/LoadingImageDark.svg";
import { useSelector } from "react-redux";
import { getThemeName } from "../../utils/utils";

const useStyle = (props) => {
  return makeStyles(({ theme }) => ({
    errorClass: {
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      paddingTop: props.paddingTop || 0,
    },
  }))();
};

export function Error({
  message = "No data found!",
  imageHeight,
  fontSize,
  margin,
  errHeight,
  paddingTop,
  loading = false,
  image = null,
}) {
  const theme = useTheme();
  const classes = useStyle({ paddingTop });
  const isDarkMode = useSelector((state) => state.selections.isDarkMode);
  const errorImage = getThemeName(isDarkMode)
    ? errorImageDark
    : errorImageLight;
  const LoadingImage = getThemeName(isDarkMode)
    ? LoadingImageDark
    : LoadingImageLight;
  return (
    <Box className={classes.errorClass}>
      <img
        style={{
          maxHeight: imageHeight,
          width: "100%",
          marginBottom: theme.size[10],
        }}
        src={image ? image : loading ? LoadingImage : errorImage}
        alt="error"
      />
      {loading && <CircularProgress size={theme.sizeRem[1]} />}
      {message && (
        <Typography
          sx={{
            textAlign: "center",
            margin: margin,
            fontSize: theme.size[13],
            fontWeight: theme.fontWeight[500],
            color: theme.palette.cards.heading,
          }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );
}

export default Error;
